/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const UserIcon = /*#__PURE__*/ createSvgIcon(
  'UserIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 10a2.893 2.893 0 01-2.125-.875A2.893 2.893 0 017 7c0-.833.292-1.542.875-2.125A2.893 2.893 0 0110 4c.833 0 1.542.292 2.125.875S13 6.167 13 7s-.292 1.542-.875 2.125A2.893 2.893 0 0110 10zm-6 4.5V14c0-.32.087-.621.26-.906a2.22 2.22 0 01.72-.719 10.242 10.242 0 012.422-1.02 9.661 9.661 0 015.192 0c.854.235 1.663.576 2.427 1.02.305.18.545.417.719.708.173.292.26.598.26.917v.5c0 .412-.147.766-.44 1.06-.295.293-.648.44-1.06.44H5.493c-.413 0-.765-.147-1.056-.44A1.45 1.45 0 014 14.5zm1.5 0h9V14a.329.329 0 00-.063-.196.421.421 0 00-.166-.137 7.812 7.812 0 00-2.042-.875A8.535 8.535 0 0010 12.5c-.764 0-1.507.097-2.23.292a7.812 7.812 0 00-2.04.875c-.07.055-.126.109-.168.16A.269.269 0 005.5 14v.5zm4.504-6c.414 0 .767-.147 1.059-.442.291-.294.437-.649.437-1.062 0-.414-.147-.767-.442-1.059A1.456 1.456 0 009.996 5.5c-.414 0-.767.147-1.059.442A1.456 1.456 0 008.5 7.004c0 .414.147.767.442 1.059.294.291.649.437 1.062.437z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default UserIcon;
